<template>
  <v-container v-if="npa">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa edit">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form-head">
              <Widget position="menu_profile"/>
            </div>
            <div class="form-body">
              <div class="status">
                <span class="draft">
                  <router-link
                    :to="$i18nRoute({
                      name: 'view-npa',
                      params: { id: npa.npa.id }
                    })"
                  >{{ $t('Статус') }}: {{ npa.npa.status.transName }}</router-link>
                </span>
              </div>
              <NpaInitiative :npa="npa" @fetch-data="fetchData"/>
              <div class="form-npa-basic">
                <div class="view-npa-body">
                  <div class="form-group data">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td>{{ $t("Идентификатор проекта НПА") }}</td>
                        <td>{{ npa.npa.id }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t("Наименование на государственном языке") }}</td>
                        <td>
                          <template v-if="!fields.nameKg.showEdit">
                            {{ npa.npa.nameKg }}
                          </template>
                          <template v-else-if="editable">
                            <InlineEdit
                              :params="fields.nameKg"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.nameKg.showEdit && editable"
                            @click="fields.nameKg.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Наименование на официальном языке") }}</td>
                        <td>
                          <template v-if="!fields.name.showEdit">
                            {{ npa.npa.name }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.name"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.name.showEdit && editable"
                            @click="fields.name.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Вид проекта НПА") }}</td>
                        <td>
                          <template v-if="!fields.view.showEdit">
                            {{ npa.npa.view.transName }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.view"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.view.showEdit && editable"
                            @click="fields.view.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr v-if="npa.npa.region || npa.npa.view.id === npa.npaViewId">
                        <td>{{ $t("Область") }}</td>
                        <td>
                          <template v-if="!fields.region.showEdit">
                            {{ npa.npa.region ? npa.npa.region.transName : '' }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.region"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.region.showEdit && editable"
                            @click="fields.region.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr v-if="npa.npa.district || npa.npa.view.id === npa.npaViewId">
                        <td>{{ $t("Район") }}</td>
                        <td>
                          <template v-if="!fields.district.showEdit">
                            {{ npa.npa.district ? npa.npa.district.transName : '' }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.district"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.district.showEdit && editable"
                            @click="fields.district.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Редакция") }}</td>
                        <td>
                          <template v-if="!fields.edition.showEdit">
                            {{ npa.npa.edition.transName }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.edition"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.edition.showEdit && editable"
                            @click="fields.edition.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Разработчик") }}</td>
                        <td>
                          <template v-if="!fields.developer.showEdit">
                            <v-icon
                              v-if="npa.npa.developer.status === false"
                              class="nv_icon mr-1"
                              x-small
                            />
                            {{ npa.npa.developer.transName }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.developer"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.developer.showEdit && editable"
                            @click="fields.developer.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Контактные лица") }}</td>
                        <td>
                          <div class="link-npa-main">
                            <ContactPersons
                              v-if="editable"
                              v-model="fields.persons"
                              ref="persons"
                              @fetchPersons="getDataPersons($event)"
                              :author-data="npa.authorData"
                              :persons-length="npa.persons.length ? npa.persons.length : 0"
                            />
                            <ul class="">
                              <li
                                v-for="(person, index) of npa.persons"
                                :key="index"
                              >
                                <div>
                                 {{index + 1}}. {{ person.fullName }} {{ person.position }} {{ person.phone }}
                                  <span
                                    v-if="editable"
                                    class="pro-icon-close"
                                    @click="deletePerson(index)"
                                  ></span>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="viewIdsCompare">
                        <td>{{ $t("Инициатор проекта НПА") }}</td>
                        <td>
                          <template v-if="!fields.initiator.showEdit">
                            {{ npa.npa.initiator ? npa.npa.initiator.transName : '' }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.initiator"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.initiator.showEdit && editable"
                            @click="fields.initiator.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Категории") }}</td>
                        <td>
                          <template v-if="!fields.category.showEdit">
                            <div class="npa-category-list">
                              <div class="tags">
                                  <span
                                    v-for="item in npa.npa.category"
                                    class="tag"
                                    :key="item.id"
                                  >
                                    {{ item.transName }}
                                    <span
                                      v-if="editable"
                                      class="pro-icon-close"
                                      @click="deleteCategory(item.id)"
                                    ></span>
                                  </span>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.category"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.category.showEdit && editable"
                            @click="fields.category.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr v-if="npa.npa.is_shortened">
                        <td>{{ $t('Доп.мероприятия') }}</td>
                        <td>{{$t('Срок обсуждения:')}} {{npa.npa.days_remaining_between}}, {{$t('Доп.мероприятия')}}: {{ npa.npa.extra_measures }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t("Отрасли") }}</td>
                        <td>
                          <template v-if="!fields.branchLaw.showEdit">
                            <div class="npa-category-list">
                              <div class="tags">
                                  <span
                                    class="tag"
                                    v-for="item in npa.npa.branch_law"
                                    :key="item.id"
                                  >
                                    {{ item.transName }}
                                    <span
                                      v-if="editable"
                                      class="pro-icon-close"
                                      @click="deleteBranchlaw(item.id)"
                                    ></span>
                                  </span>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.branchLaw"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.branchLaw.showEdit && editable"
                            @click="fields.branchLaw.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Цель проекта НПА на государственном языке") }}</td>
                        <td>
                          <template v-if="!fields.projectGoalKg.showEdit">
                            <div v-html="npa.npa.project_goal_kg"></div>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.projectGoalKg"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.projectGoalKg.showEdit && editable"
                            @click="fields.projectGoalKg.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Цель проекта НПА на официальном языке") }}</td>
                        <td>
                          <template v-if="!fields.projectGoal.showEdit">
                            <div v-html="npa.npa.project_goal"></div>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.projectGoal"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.projectGoal.showEdit && editable"
                            @click="fields.projectGoal.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Дата публикации") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu"
                              v-model="fields.publishDate.menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <a v-on="on">
                                  {{
                                    new Date(npa.npa.publish_date)
                                      | dateFormat('DD.MM.YYYY')
                                  }}
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.publishDate.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateDate"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                      <tr v-if="!isInitiativeGroupUser">
                        <td>{{ $t("Период обсуждения проекта") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu2"
                              v-model="fields.DateFrom.menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <a v-on="on">
                                  {{
                                    new Date(npa.npa.discussion_period_date_from)
                                      | dateFormat('DD.MM.YYYY')
                                  }}
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.DateFrom.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateDateFrom"
                              />
                            </v-menu>
                          </template>
                          -
                          <template>
                            <v-menu
                              ref="menu3"
                              v-model="fields.DateTo.menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <a v-on="on">
                                  {{
                                    new Date(npa.npa.discussion_period_date_to)
                                      | dateFormat('DD.MM.YYYY')
                                  }}
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.DateTo.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                min="2000-01-01"
                                @change="updateDateTo"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Ключевые слова") }}</td>
                        <td>
                          <template v-if="!fields.keyword.showEdit">
                            <div class="form-keywords">
                              <div class="tags">
                                  <span
                                    class="tag"
                                    v-for="item in npa.npa.keyword"
                                    :key="item.id"
                                  >
                                    #{{ item.transName }}
                                    <span
                                      v-if="editable"
                                      class="pro-icon-close"
                                      @click="deleteKeyword(item.id)"
                                    ></span>
                                  </span>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.keyword"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.keyword.showEdit && editable"
                            @click="fields.keyword.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Требует финансирования") }}</td>
                        <td>
                          <template v-if="!fields.fundingRequired.showEdit">
                              <span
                                v-if="
                                  npa.npa.funding_required &&
                                    npa.npa.funding_required === true
                                "
                              >{{ $t("да") }}</span
                              >
                            <span v-else>{{ $t("нет") }}</span>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.fundingRequired"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.fundingRequired.showEdit && editable"
                            @click="fields.fundingRequired.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Затрагивает предпринимательскую деятельность") }}</td>
                        <td>
                          <template
                            v-if="!fields.entrepreneurshipAffect.showEdit"
                          >
                              <span
                                v-if="
                                  npa.npa.entrepreneurship_affect &&
                                    npa.npa.entrepreneurship_affect === true
                                "
                              >{{ $t("да") }}</span
                              >
                            <span v-else>{{ $t("нет") }}</span>
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.entrepreneurshipAffect"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="
                                !fields.entrepreneurshipAffect.showEdit && editable
                              "
                            @click="fields.entrepreneurshipAffect.showEdit = true"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Ссылки на НПА") }}</td>
                        <td>
                          <div class="link-npa-main">
                            <NpaLinks
                              v-if="editable"
                              v-model="fields.links"
                              ref="links"
                              @fetchLinks="getDataLinks($event)"
                            />
                            <ul class="link-list">
                              <li
                                v-for="(link, index) of npa.links"
                                :key="index"
                              >
                                <a
                                  target="_blank"
                                  :href="link.text"
                                  class="link-npa"
                                >
                                  {{ link.text }}
                                </a>
                                <span
                                  v-if="editable"
                                  class="pro-icon-close"
                                  @click="deleteLink(index)"
                                ></span>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="npa.jkData">
                        <td>{{ $t("Проект в ЖК") }}</td>
                        <td>
                          <div class="jk-info-block">
                            <span>
                              № {{ npa.jkData.registrationNumber }}
                              от {{ npa.jkData.publishDate }}
                            </span>
                            <br>
                            <a :href="npa.jkData.url" target="_blank" class="font-weight-bold">
                              «{{ npa.jkData.title }}»
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="d-flex align-center mt-2 mb-n5" v-if="npa.npa.discussClosedStatus">
                      <button
                        type="button"
                        class="btn btn-default btn-sm mr-2"
                        @click="jkDialog = true"
                      >
                        {{ $t("Добавить идентификатор в ЖК") }}
                      </button>
                    </div>
                  </div>
                  <div class="npa-version">
                    <input
                      id="fileVersion"
                      ref="fileVersion"
                      type="file"
                      class="hide"
                      @change="handleFileUploadVersion"
                    />
                    <v-tabs v-model="activeTab">
                      <v-tab
                        v-for="npaVersions in npa.npaVersions"
                        :key="npaVersions.id"
                      >
                        {{ npaVersions.npaVersion.version.transName }}
                      </v-tab>
                      <v-tab key="npaDocuments">
                        {{ $t("Сопроводительные документы") }}
                      </v-tab>
                      <v-tab key="npaExaminations">
                        {{ $t("Результаты специализированных видов экспертиз") }}
                      </v-tab>
                      <v-tab key="npaInitiativeGroup" v-if="showInitiativeGroupTab">
                        {{ $t("Инициативная группа") }}
                      </v-tab>
                      <v-tab key="npaHistory" v-if="npaPromotionHistories.length > 0 || historyEditable">
                        {{ $t("История продвижения проекта") }}
                      </v-tab>
                      <v-tab key="npaHistoryChanges" v-if="historyChangeEditable">
                        {{ $t("История изменений") }}
                      </v-tab>
                      <v-tab-item
                        v-for="npaVersions in npa.npaVersions"
                        :key="npaVersions.id"
                      >
                        <div class="version-head">
                          <div class="form-group files">
                            <table class="table table-data">
                              <tbody>
                              <tr :class="{ invalid: $v.npaVersionFiles.fileKg.$error }" >
                                <td>
                                  {{ $t("Файл проекта НПА на государственном языке") }}
                                </td>
                                <td>
                                  <a
                                    href="#"
                                    class="btn-add"
                                    @click="
                                        changeFileVersion(
                                          npaVersions.npaVersion.id,
                                          'kg'
                                        )
                                      "
                                    v-if="
                                        npaVersions.npaVersion.file_kg === null &&
                                          editable
                                      "
                                  >
                                    <span class="pro-icon-add"></span>
                                  </a>
                                  <div class="file-list">
                                    <template
                                      v-if="
                                          npaVersions.npaVersion.file_kg !== null
                                        "
                                    >
                                      <a
                                        :href="
                                            baseUrl +
                                              npaVersions.npaVersion
                                                .fullFilesDirectoryKg
                                          "
                                        class="file-link"
                                      >
                                        <i
                                          v-if="
                                              npaVersions.npaVersion.fileExtensionKg
                                            "
                                          :class="
                                              'pro-icon-' +
                                                npaVersions.npaVersion
                                                  .fileExtensionKg
                                            "
                                        ></i>
                                        {{ $t("Скачать Файл проекта НПА на государственном языке") }}
                                      </a>
                                      <a
                                        href="#"
                                        class="btn-add"
                                        v-if="editable"
                                        @click="
                                            changeFileVersion(
                                              npaVersions.npaVersion.id,
                                              'kg'
                                            )
                                          "
                                      >
                                        <span class="pro-icon-pencil"></span>
                                      </a>
                                    </template>
                                  </div>
                                  <span
                                    v-if="$v.npaVersionFiles.fileKg.$dirty && !npaVersionFileKgValid"
                                    class="invalid"
                                  >{{ $t("Загрузите файл") }}</span>
                                </td>
                              </tr>
                              <tr :class="{ invalid: $v.npaVersionFiles.file.$error }">
                                <td>{{ $t("Файл проекта НПА на официальном языке") }}</td>
                                <td>
                                  <a
                                    href="#"
                                    class="btn-add"
                                    @click="
                                        changeFileVersion(
                                          npaVersions.npaVersion.id,
                                          'ru'
                                        )
                                      "
                                    v-if="
                                        npaVersions.npaVersion.file === null &&
                                          editable
                                      "
                                  >
                                    <span class="pro-icon-add"></span>
                                  </a>
                                  <div class="file-list">
                                    <template
                                      v-if="npaVersions.npaVersion.file !== null"
                                    >
                                      <a
                                        v-if="
                                            npaVersions.npaVersion.file !== null
                                          "
                                        :href="
                                            baseUrl +
                                              npaVersions.npaVersion
                                                .fullFilesDirectory
                                          "
                                        class="file-link"
                                      >
                                        <i
                                          v-if="
                                              npaVersions.npaVersion.fileExtension
                                            "
                                          :class="
                                              'pro-icon-' +
                                                npaVersions.npaVersion.fileExtension
                                            "
                                        ></i>
                                        {{ $t("Скачать Файл проекта НПА на официальном языке") }}
                                      </a>
                                      <a
                                        href="#"
                                        class="btn-add"
                                        v-if="editable"
                                        @click="
                                            changeFileVersion(
                                              npaVersions.npaVersion.id,
                                              'ru'
                                            )
                                          "
                                      >
                                        <span class="pro-icon-pencil"></span>
                                      </a>
                                    </template>
                                  </div>
                                  <span
                                    v-if="$v.npaVersionFiles.file.$dirty && !npaVersionFileValid"
                                    class="invalid"
                                  >{{ $t("Загрузите файл") }}</span>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="version-body">
                          <div class="form-group text">
                            <v-tabs class="tab-text-version">
                              <v-tab :key="'kgBlock' + npaVersions.id">
                                {{ $t("Текст проекта НПА на государственном языке") }}
                              </v-tab>
                              <v-tab :key="'ruBlock' + npaVersions.id">
                                {{ $t("Текст проекта НПА на официальном языке") }}
                              </v-tab>
                              <v-tab-item :key="'kgBlock' + npaVersions.id" :class="{ invalid: $v.npaVersionBlocks.blockKg.$error }">
                                <div class="form-text-area" v-show="showText">
                                  <span
                                    v-if="$v.npaVersionBlocks.blockKg.$dirty && !npaVersionBlockKgValid"
                                    class="invalid"
                                  >{{ $t("Заполните текст проекта НПА") }}</span>
                                  <div class="flexbox add-block-top">
                                    <NpaVersionBlocks
                                      v-if="editable"
                                      :type="'start'"
                                      :versionId="npaVersions.npaVersion.id"
                                      :id="'start' + npaVersions.npaVersion.id"
                                      :lang="'kg'"
                                      :label="'Добавление блока в начало'"
                                      :blockCommented="true"
                                      :btnLabel="'Добавление блока в начало'"
                                      :iconClass="'pro-icon-add'"
                                      @setDataBlock="getDataBlock($event)"
                                    />
                                    <NpaVersionBlocks
                                      v-if="editable"
                                      :type="'end'"
                                      :versionId="npaVersions.npaVersion.id"
                                      :id="'start' + npaVersions.npaVersion.id"
                                      :lang="'kg'"
                                      :label="'Добавление блока в конец'"
                                      :blockCommented="true"
                                      :btnLabel="'Добавление блока в конец'"
                                      :iconClass="'pro-icon-add'"
                                      @setDataBlock="getDataBlock($event)"
                                    />
                                  </div>
                                  <article
                                    v-for="npaVersionBlocksKg in npaVersions.npaVersionBlocksKg"
                                    :key="npaVersionBlocksKg.id"
                                  >
                                    <div v-if="editable" class="block-control mini">
                                      <div class="flexbox">
                                        <NpaVersionBlocks
                                          :type="'before'"
                                          :versionId="npaVersions.npaVersion.id"
                                          :blockId="npaVersionBlocksKg.id"
                                          :id="'before' + npaVersionBlocksKg.id"
                                          :lang="'kg'"
                                          :label="
                                            'Добавление блока перед текущим блоком'
                                          "
                                          :blockCommented="true"
                                          :btnLabel="''"
                                          :iconClass="'pro-icon-add'"
                                          @setDataBlock="getDataBlock($event)"
                                        />
                                        <NpaVersionBlocks
                                          :type="'edit'"
                                          :versionId="npaVersions.npaVersion.id"
                                          :blockId="npaVersionBlocksKg.id"
                                          :id="'edit' + npaVersionBlocksKg.id"
                                          :lang="'kg'"
                                          :label="'Редактирование блока'"
                                          :btnLabel="''"
                                          :blockValue="npaVersionBlocksKg.text"
                                          :blockCommented="
                                            npaVersionBlocksKg.commented
                                          "
                                          :iconClass="'pro-icon-pencil'"
                                          @setDataBlock="getDataBlock($event)"
                                        />
                                        <v-btn
                                          class="btn-add"
                                          @click="
                                            deleteBlock(
                                              npaVersionBlocksKg.id,
                                              npaVersions.npaVersion.id
                                            )
                                          "
                                        >
                                          <i class="pro-icon-close"></i>
                                        </v-btn>
                                      </div>
                                    </div>
                                    <div v-html="npaVersionBlocksKg.text != 'null' ? npaVersionBlocksKg.text : ''"></div>
                                  </article>
                                </div>
                              </v-tab-item>
                              <v-tab-item :key="'ruBlock' + npaVersions.id" :class="{ invalid: $v.npaVersionBlocks.block.$error }">
                                <div class="form-text-area" v-show="showText">
                                  <span
                                    v-if="$v.npaVersionBlocks.block.$dirty && !npaVersionBlockValid"
                                    class="invalid"
                                  >{{ $t("Заполните текст проекта НПА") }}</span>
                                  <div class="flexbox add-block-top">
                                    <NpaVersionBlocks
                                      v-if="editable"
                                      :type="'start'"
                                      :versionId="npaVersions.npaVersion.id"
                                      :id="'start' + npaVersions.npaVersion.id"
                                      :lang="'ru'"
                                      :label="'Добавление блока в начало'"
                                      :blockCommented="true"
                                      :btnLabel="'Добавление блока в начало'"
                                      :iconClass="'pro-icon-add'"
                                      @setDataBlock="getDataBlock($event)"
                                    />
                                    <NpaVersionBlocks
                                      v-if="editable"
                                      :type="'end'"
                                      :versionId="npaVersions.npaVersion.id"
                                      :id="'start' + npaVersions.npaVersion.id"
                                      :lang="'ru'"
                                      :label="'Добавление блока в конец'"
                                      :blockCommented="true"
                                      :btnLabel="'Добавление блока в конец'"
                                      :iconClass="'pro-icon-add'"
                                      @setDataBlock="getDataBlock($event)"
                                    />
                                  </div>
                                  <article
                                    v-for="npaVersionBlocksRu in npaVersions.npaVersionBlocksRu"
                                    :key="npaVersionBlocksRu.id"
                                  >
                                    <div v-if="editable" class="block-control mini">
                                      <div class="flexbox">
                                        <NpaVersionBlocks
                                          :type="'before'"
                                          :versionId="npaVersions.npaVersion.id"
                                          :blockId="npaVersionBlocksRu.id"
                                          :id="'before' + npaVersionBlocksRu.id"
                                          :lang="'ru'"
                                          :label="
                                            'Добавление блока перед текущим блоком'
                                          "
                                          :blockCommented="true"
                                          :btnLabel="''"
                                          :iconClass="'pro-icon-add'"
                                          @setDataBlock="getDataBlock($event)"
                                        />
                                        <NpaVersionBlocks
                                          :type="'edit'"
                                          :versionId="npaVersions.npaVersion.id"
                                          :blockId="npaVersionBlocksRu.id"
                                          :id="'edit' + npaVersionBlocksRu.id"
                                          :lang="'ru'"
                                          :label="'Редактирование блока'"
                                          :btnLabel="''"
                                          :blockValue="npaVersionBlocksRu.text"
                                          :blockCommented="
                                            npaVersionBlocksRu.commented
                                          "
                                          :iconClass="'pro-icon-pencil'"
                                          @setDataBlock="getDataBlock($event)"
                                        />
                                        <v-btn
                                          class="btn-add"
                                          @click="
                                            deleteBlock(
                                              npaVersionBlocksRu.id,
                                              npaVersions.npaVersion.id
                                            )
                                          "
                                        >
                                          <i class="pro-icon-close"></i>
                                        </v-btn>
                                      </div>
                                    </div>
                                    <div v-html="npaVersionBlocksRu.text != 'null' ? npaVersionBlocksRu.text : ''"></div>
                                  </article>
                                </div>
                              </v-tab-item>
                            </v-tabs>
                            <div class="form-text">
                              <div class="form-text-bottom">
                                <a
                                  href="#!"
                                  class="btn-collapse"
                                  @click="showText = !showText"
                                >
                                  <span class="show" v-show="showText"
                                  >{{ $t("Свернуть") }}
                                  </span>
                                  <span class="show" v-show="!showText"
                                  >{{ $t("Показать") }}
                                  </span>
                                  {{ $t("Текст") }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item key="npaDocuments">
                        <div class="version-head npa-documents">
                          <Document
                            ref="document"
                            v-if="editable || editableDocument"
                            @setDataDocs="getDocsData($event)"
                          />
                        </div>
                        <div class="version-body">
                          <div class="form-group files">
                            <ul v-if="npa.npaDocuments" class="npa-document-list">
                              <li
                                v-for="document in npa.npaDocuments"
                                :key="document.id"
                              >
                                <template v-if="document.fileExtension === 'pdf'">
                                  <a
                                    class="file-link"
                                    :href="baseUrl + document.fullFilesDirectory"
                                    target="_blank"
                                  >
                                    <i
                                      v-if="document.fileExtension"
                                      :class="'pro-icon-' + document.fileExtension"
                                    ></i>
                                    {{ document.type.transName }}
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    class="file-link"
                                    @click="
                                      previewDocumentDialog(document.id, true)
                                    "
                                  >
                                    <i
                                      v-if="document.fileExtension"
                                      :class="'pro-icon-' + document.fileExtension"
                                    ></i>
                                    {{ document.type.transName }}
                                  </a>
                                  <span
                                    v-if="editable || editableDocument"
                                    class="pro-icon-close"
                                    @click="deleteDocument(document.id)"
                                  ></span>
                                  <v-dialog
                                    v-model="previewDocsModal[document.id]"
                                    max-width="1200"
                                  >
                                    <v-card class="modal">
                                      <div class="modal-head">
                                        {{ document.type.transName }}
                                        <v-btn
                                          color="modal-close"
                                          @click="
                                            previewDocumentDialog(
                                              document.id,
                                              false
                                            )
                                          "
                                        >
                                          <span class="pro-icon-close1"></span>
                                        </v-btn>
                                      </div>
                                      <div class="modal-body">
                                        <OfficePreviewBridge
                                          :file-url="baseUrl + document.fullFilesDirectory"
                                        />
                                      </div>
                                    </v-card>
                                  </v-dialog>
                                </template>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item key="npaExaminations">
                        <div class="version-head npa-examinations">
                          <Examinations
                            ref="examination"
                            v-if="editable || editableExamination"
                            @setDataExaminations="getExaminationsData($event)"
                          />
                        </div>
                        <div class="version-body">
                          <div class="form-group files">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                <tr>
                                  <th class="text-left">
                                    {{$t('Наименование')}}
                                  </th>
                                  <th>
                                    {{ $t('Категории') }}
                                  </th>
                                  <th class="text-left">
                                    {{$t('Комментарии')}}
                                  </th>
                                  <th class="text-left">
                                    {{$t('Автор')}}
                                  </th>
                                  <th class="text-left">
                                    {{$t('Файлы')}}
                                  </th>
                                  <th v-if="editable || editableExamination" class="text-left">
                                    {{$t('')}}
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                  v-for="examination in npa.npaExaminations"
                                  :key="examination.id"
                                >
                                  <td>{{ examination.name }}</td>
                                  <td>{{ examination.examination_categories.length ? examination.examination_categories.map(c => c.transName).join(', ') : '' }}</td>
                                  <td>{{ examination.comment }}</td>
                                  <td>{{examination.user.first_name}} {{examination.user.second_name}} {{examination.user.last_name}}</td>
                                  <td>
                                    <div v-for="document in examination.documents" :key="document.id">
                                      <template v-if="document.fileExtension === 'pdf'">
                                        <a
                                          class="file-link"
                                          :href="baseUrl + document.fullFilesDirectory"
                                          target="_blank"
                                        >
                                          <i
                                            v-if="document.fileExtension"
                                            :class="'pro-icon-' + document.fileExtension"
                                          ></i>
                                          {{ document.name }}
                                        </a>
                                      </template>
                                      <template v-else>
                                        <a @click="previewDocumentDialog(document.id, true)">
                                          <i v-if="document.fileExtension" :class="'pro-icon-' + document.fileExtension"></i>
                                          {{ document.name }}
                                        </a>
                                        <v-btn
                                          v-if="editable || editableExamination"
                                          fab
                                          dark
                                          x-small
                                          @click="deleteExaminationDocument( examination.id, document.id)"
                                        >
                                          <v-icon dark>
                                            mdi-close
                                          </v-icon>
                                        </v-btn>
                                        <v-dialog
                                          v-model="previewDocsModal[document.id]"
                                          max-width="1200"
                                        >
                                          <v-card class="modal">
                                            <div class="modal-head">
                                              {{ document.name }}
                                              <v-btn
                                                color="modal-close"
                                                @click="
                                                previewDocumentDialog(document.id,false)">
                                                <span class="pro-icon-close1"></span>
                                              </v-btn>
                                            </div>
                                            <div class="modal-body">
                                              <OfficePreviewBridge
                                                :file-url="baseUrl + document.fullFilesDirectory"
                                              />
                                            </div>
                                          </v-card>
                                        </v-dialog>
                                      </template>
                                    </div>
                                  </td>
                                  <td v-if="editable || editableExamination">
                                    <v-btn
                                      class="mx-2"
                                      fab
                                      dark
                                      small
                                      @click="deleteExamination(examination.id)"
                                    >
                                      <v-icon dark>
                                        mdi-close
                                      </v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item key="npaInitiativeGroup" v-if="showInitiativeGroupTab">
                        <div class="version-body">
                          <div class="table-overflow">
                            <table class="table table-data">
                              <tbody>
                              <tr>
                                <td>{{ $t('Наименование') }}</td>
                                <td>{{ initiativeGroupData.transName }}</td>
                              </tr>
                              <tr>
                                <td>{{ $t('Регистрационный номер') }}</td>
                                <td>{{ initiativeGroupData.reg_number }}</td>
                              </tr>
                              <tr>
                                <td>{{ $t('Дата регистрации') }}</td>
                                <td>
                                  <template v-if="initiativeGroupData.reg_date">
                                    {{ new Date(initiativeGroupData.reg_date) | dateFormat('DD.MM.YYYY') }}
                                  </template>
                                </td>
                              </tr>
                              <tr>
                                <td>{{ $t('Наименование органа, выдавшего свидетельство о регистрации') }}</td>
                                <td>{{ initiativeGroupData.reg_authority }}</td>
                              </tr>
                              <tr>
                                <td>{{ $t('Данные о руководителях') }}</td>
                                <td v-html="initiativeGroupData.leaders"></td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item key="npaHistory" v-if="npaPromotionHistories.length > 0 || historyEditable">
                        <div class="npa-promotion-history">
                          <NpaPromotionHistoryAdd
                            v-if="historyEditable"
                            :npaId="npa.npa.id"
                            v-bind:npaPromotionHistories.sync="npaPromotionHistories"
                          />
                          <div class="table-overflow">
                            <table class="table table-cell-fix"
                                   :class="{ 'history-promotion-table': !historyEditable }">
                              <thead>
                              <tr>
                                <td class="td-num">№</td>
                                <td class="full-name-td">{{ $t('Стадия') }}</td>
                                <td class="td-date">{{ $t('Дата') }}</td>
                                <td class="td-action">{{ $t('Действия') }}</td>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(promotionHistory, i) in npaPromotionHistories" :key="promotionHistory.id">
                                <td class="td-num">{{ ++i }}</td>
                                <td class="full-name-td">
                                  {{ promotionHistory.transName }}
                                </td>
                                <td class="td-date">
                                  <template v-if="promotionHistory.date">
                                    {{ new Date(promotionHistory.date) | dateFormat('DD.MM.YYYY') }}
                                  </template>
                                </td>
                                <td class="td-action">
                                  <div class="td-action__flex">
                                    <template v-if="historyEditable">
                                      <NpaPromotionHistoryAdd
                                        :npaPromotionHistoryId="promotionHistory.id"
                                        :npaPromotionHistoryEdit="true"
                                        :npaId="npa.npa.id"
                                        v-bind:npaPromotionHistories.sync="npaPromotionHistories"
                                      />
                                      <v-btn class="btn-add btn-delete"
                                             @click.native.stop="deletePromotionHistory(promotionHistory.id)">
                                        <v-icon>delete_forever</v-icon>
                                      </v-btn>
                                    </template>
                                    <template v-if="promotionHistory.documentsCount > 0 || promotionHistory.documentsUpload === true">
                                      <NpaPromotionHistoryDocs
                                        :documentsUpload="promotionHistory.documentsUpload"
                                        :npaPromotionHistoryId="promotionHistory.id"
                                        :historyEditable="historyEditable"
                                      />
                                    </template>
                                  </div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item key="npaHistoryChanges" v-if="historyChangeEditable">
                        <div class="npa-history-changes">
                          <NpaHistoryChanges
                            v-bind:npaHistoryChanges.sync="npaHistoryChanges"
                          />
                        </div>
                      </v-tab-item>
                    </v-tabs>
                  </div>
                </div>
                <div class="form-group form-action">
                  <template v-for="actionPermission in actionPermissions">
                    <v-btn
                      :key="actionPermission.id"
                      @click="action(actionPermission)"
                      :class="actionPermission.class"
                      v-if="actionPermission.type != 'npa_result'"
                      rounded
                    >
                      {{ actionPermission.name }}
                    </v-btn>
                    <template v-if="actionPermission.type == 'npa_result'">
                      <NpaResultForm
                        :npa="npa.npa"
                        :actionPermission="actionPermission"
                        @saveResult="updateNpa($event)"
                        :key="actionPermission.id"
                      />
                    </template>
                    <template v-if="actionPermission.type == 'npa_stages'">
                      <v-dialog
                        v-model="npaStagesDialog"
                        scrollable
                        max-width="600px"
                        :key="actionPermission.id"
                      >
                        <NpaStagesForm
                          :npa="npa.npa"
                          @cancel="npaStagesDialog = false"
                          @save="npaStagesDialog = false"
                        />
                      </v-dialog>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Модальное окно ЖК -->
    <v-dialog v-model="jkDialog" max-width="700px">
      <v-card class="pa-4">
        <v-card-title class="headline">{{ $t("Добавление идентификатора ЖК") }}</v-card-title>
        <v-card-text>
          <p class="mb-4">
            Для добавления истории по рассмотрению проекта в Жогорку Кенеш введите идентификатор проекта НПА с сайта ЖК.
            Для этого на сайте по ссылке <a href="https://kenesh.kg/bills/" target="_blank">https://kenesh.kg/bills/</a>
            найдите нужный проект НПА и в адресной строке скопируйте идентификатор.
            В этом случае история рассмотрения проекта НПА в ЖК будет обновляться здесь автоматически.
          </p>

          <!-- Место для картинки-инструкции -->
          <v-img
            src="@/assets/instruction-jk.png"
            contain
            max-height="40"
            class="mb-4"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <span class="caption">Скриншот-инструкция (ID в адресной строке)</span>
              </v-row>
            </template>
          </v-img>

          <v-text-field
            v-model="jkIdInput"
            label="Идентификатор ЖК"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="jkDialog = false">{{ $t("Отмена") }}</v-btn>
          <v-btn color="primary" @click="saveJkIdentifier">{{ $t("Сохранить") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Search from '@/model/search'
import User from '@/model/user'
import {mapMutations} from 'vuex'
import Widget from '@/components/app/Widget'
import InlineEdit from '@/components/npa/InlineEdit'
import Npa from '@/store/modules/getNpaData'
import NpaLinks from '@/components/npa/Links'
import ContactPersons from '@/components/npa/ContactPersons.vue'
import Document from '@/components/npa/Documents'
import Examinations from '@/components/npa/Examinations.vue'
import NpaPromotionHistoryAdd from '@/components/npa/NpaPromotionHistoryAdd'
import OfficePreviewBridge from '@/components/app/OfficePreviewBridge.vue'
import moment from 'moment'
import NpaVersionBlocks from '@/components/npa/NpaVersionBlocks'
import NpaStagesForm from '@/components/npa/NpaStagesForm'
import NpaResultForm from '@/components/npa/NpaResultForm'
import mixin from '@/plugins/mixin/mixin'
import NpaModel from '@/model/npa'
import NpaPromotionHistoryDocs from '@/components/npa/NpaPromotionHistoryDocs'
import NpaHistoryChanges from '@/components/npa/NpaHistoryChanges'
import {Trans} from "@/plugins/Translation"
import { required } from 'vuelidate/lib/validators'
import NpaInitiative from '@/components/npa/NpaInitiative.vue'

export default {
  mixins: [mixin],
  components: {
    NpaInitiative,
    NpaPromotionHistoryDocs,
    Widget,
    InlineEdit,
    NpaLinks,
    Document,
    OfficePreviewBridge,
    NpaVersionBlocks,
    NpaStagesForm,
    NpaResultForm,
    NpaPromotionHistoryAdd,
    NpaHistoryChanges,
    ContactPersons,
    Examinations
  },
  data() {
    return {
      npa: {},
      breadcrumbs: [],
      fields: null,
      baseUrl: process.env.VUE_APP_BACK_URL,
      links: [],
      persons: [],
      catId: [],
      documentsData: {},
      actionPermissions: null,
      editable: false,
      editableDocument: false,
      editableExamination: false,
      previewDocsModal: [],
      showText: true,
      blockData: {},
      confirmMessage: 'Вы действительно хотите выполнить данное действие?',
      currentVersionIdFile: null,
      currentLangFile: null,
      npaStagesDialog: false,
      updateActionList: false,
      viewIdsCompare: false,
      activeTab: 0,
      historyEditable: false,
      npaPromotionHistories: [],
      historyChangeEditable: false,
      npaHistoryChanges: [],
      rules: {
        npaVersionFiles: {
          fileKg: {},
          file: {}
        },
        npaVersionBlocks: {
          blockKg: {},
          block: {}
        }
      },
      jkDialog: false,
      jkIdInput: '',
    }
  },
  validations () {
    if (!this.npaVersionFileKgValid) {
      this.rules.npaVersionFiles.fileKg = { required }
    } else {
      this.rules.npaVersionFiles.fileKg = {}
    }
    if (!this.npaVersionFileValid) {
      this.rules.npaVersionFiles.file = { required }
    } else {
      this.rules.npaVersionFiles.file = {}
    }
    if (!this.npaVersionBlockKgValid) {
      this.rules.npaVersionBlocks.blockKg = { required }
    } else {
      this.rules.npaVersionBlocks.blockKg = {}
    }
    if (!this.npaVersionBlockValid) {
      this.rules.npaVersionBlocks.block = { required }
    } else {
      this.rules.npaVersionBlocks.block = {}
    }

    return this.rules
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData'
  },
  computed: {
    npaVersionFileKgValid() {
      if (this.npa.npaVersions[0].npaVersion.file_kg) {
        return true;
      } else {
        return false;
      }
    },
    npaVersionFileValid() {
      if (this.npa.npaVersions[0].npaVersion.file) {
        return true;
      } else {
        return false;
      }
    },
    npaVersionBlockKgValid() {
      if (this.npa.npaVersions[0].npaVersionBlocksKg.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    npaVersionBlockValid() {
      if (this.npa.npaVersions[0].npaVersionBlocksRu.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    user() {
      return this.$store.state.getUser.currentUser
    },
    isInitiativeGroupUser() {
      return this.user && this.user.roleInitiativeGroupUser === true;
    },
    initiativeGroupData() {
      if (!this.npa || !this.npa.npa || !this.npa.npa.author) {
        return {}
      }

      return this.npa.npa.author.initiative_group || {}
    },
    showInitiativeGroupTab() {
      if (!this.npa || !this.npa.npa || !this.npa.npa.status || !this.npa.npa.author) {
        return false
      }

      return this.npa.npa.status.id === 12
    },
  },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // подгрузка данных
    fetchData() {
      this.setLoading(true)
      Search.getNpa(this.$route.params.id).then((response) => {
        this.npa = response.data
        this.setLoading(false)
        this.initFields()
        this.generateBreadcrumbs(this.npa.npa.transName)
        this.getNpaPromotionHistoryList(this.npa.npa.id)
        this.getNpaHistoryChangeList(this.npa.npa.id)
        this.getActionPermissions()
        this.showInitiator()
      }).catch((error) => {
        this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
        this.setLoading(false)
      })
    },
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // отображение инициатора
    showInitiator() {
      if (this.npa.viewIds && this.npa.viewIds.includes(this.npa.npa.view.id)) {
        this.viewIdsCompare = true
      } else {
        this.viewIdsCompare = false
      }
    },
    // предпросмотр файлов
    previewDocumentDialog(id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    // изменение действия
    getActionPermissions() {
      User.getActionPermissions(this.npa.npa.id).then((response) => {
        this.actionPermissions = response.data
      })
    },
    updateNpa(data) {
      this.npa.npa = data.npa
      this.getActionPermissions()
      this.getNpaHistoryChangeList(this.npa.npa.id)
    },
    // действия
    action(actionPermission) {
      if (actionPermission.type == 'npa_edit') {
        this.editable = true
        this.$vuetify.goTo('.view-npa-body')
        return
      }
      if (actionPermission.type == 'npa_cancel') {
        this.editable = false
        this.editableDocument = false
        this.$vuetify.goTo('.view-npa-body')
        return
      }

      if (actionPermission.type == 'npa_stages') {
        this.npaStagesDialog = true

        return
      }

      if (actionPermission.type == 'npa_status') {
        if (actionPermission.id == 6 && this.npa?.persons?.length === 0) {
          alert('Необходимо ввести хотя бы одно контактное лицо');
          return;
        }
        if (actionPermission.npaStatusId === this.npa.publicNpaStatusId) {
          this.npa.npaVersions.forEach(element => {
            if (element.npaVersion.file === null
              || element.npaVersion.file_kg === null
              || element.npaVersionBlocksRu.length === 0
              || element.npaVersionBlocksKg.length === 0) {
                if (!this.validateForm()) {
                  return
                }
            } else {
              this.setLoading(true)
              Npa.status(this.npa.npa.id, {id: actionPermission.id}).then(
                (response) => {
                  this.npa.npa = response.data.npa
                  this.getActionPermissions()
                }
              )
              this.setLoading(false)
            }
          })
        } else {
          let comment = null;
          if (actionPermission.id === 7) {
            comment = prompt('Укажите причину снятия с публикации') || null;
          }
          Npa.status(this.npa.npa.id, {id: actionPermission.id, comment}).then(
            (response) => {
              this.npa.npa = response.data.npa
              this.getActionPermissions()
            }
          )
        }

        return
      }
      if (actionPermission.type == 'npa_document_edit') {
        const npaVersions = this.npa.npaVersions
        this.editableDocument = true
        this.activeTab = npaVersions.length
        this.$vuetify.goTo('.npa-documents')
        return
      }

      if (actionPermission.type == 'npa_examination_edit') {
        console.log(actionPermission.type)
        const npaVersions = this.npa.npaVersions
        this.editableExamination = true
        this.activeTab = npaVersions.length + 1
        this.$vuetify.goTo('.npa-examinations')
        return
      }

      if (actionPermission.type == 'npa_promotion_history') {
        const npaVersions = this.npa.npaVersions
        const initiativeGroupTabOffset = this.showInitiativeGroupTab ? 1 : 0
        if (this.historyChangeEditable) {
          this.activeTab = npaVersions.length + 2 + initiativeGroupTabOffset
        } else {
          this.activeTab = npaVersions.length + 1 + initiativeGroupTabOffset
        }
        this.historyEditable = !this.historyEditable
        return
      }

      if (actionPermission.type == 'npa_field_history') {
        const npaVersions = this.npa.npaVersions
        const initiativeGroupTabOffset = this.showInitiativeGroupTab ? 1 : 0
        if (this.npaPromotionHistories.length > 0 || this.historyEditable === true) {
          this.activeTab = npaVersions.length + 2 + initiativeGroupTabOffset
        } else {
          this.activeTab = npaVersions.length + 1 + initiativeGroupTabOffset
        }
        this.historyChangeEditable = !this.historyChangeEditable
        return
      }
    },
    //добавляем ссылки и записываем в базу
    getDataLinks(links) {
      this.links = links
      let link = []
      this.links.forEach(function (element) {
        link.push({text: element})
      })
      this.npa.links?.forEach(function (element) {
        link.push({text: element.text})
      })
      Npa.updateNpa({links: link}, this.npa.npa.id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.$refs.links.resetLinks()
          this.setLoading(false)
        })
      })
    },
    //удаляем ссылку с базы
    deleteLink(index) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.links.splice(index, 1)
      Npa.updateNpa({links: this.npa.links}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    getDataPersons(persons) {
      this.persons = persons
      let person = []
      this.persons.forEach(function (element) {
        person.push(element)
      })
      this.npa.persons?.forEach(function (element) {
        person.push(element)
      })
      Npa.updateNpa({persons: person}, this.npa.npa.id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.$refs.persons.resetPersons()
          this.setLoading(false)
        })
      })
    },
    //удаляем ссылку с базы
    deletePerson(index) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.persons.splice(index, 1)
      Npa.updateNpa({persons: this.npa.persons}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    //удаляем категорию с базы
    deleteCategory(id) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.npa.category = this.npa.npa.category.filter(
        (item) => Number(item.id) !== Number(id)
      )

      var catId = []

      this.npa.npa.category.forEach(function (element) {
        catId.push(element.id)
      })

      Npa.updateNpa({category: catId}, this.npa.npa.id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    //удаляем Отрасли с базы
    deleteBranchlaw(id) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.npa.branch_law = this.npa.npa.branch_law.filter(
        (item) => Number(item.id) !== Number(id)
      )

      var branchId = []

      this.npa.npa.branch_law.forEach(function (element) {
        branchId.push(element.id)
      })

      Npa.updateNpa({branchLaw: branchId}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    //удаляем ключевые слова с базы
    deleteKeyword(id) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.npa.keyword = this.npa.npa.keyword.filter(
        (item) => Number(item.id) !== Number(id)
      )

      var keywordId = []

      this.npa.npa.keyword.forEach(function (element) {
        keywordId.push(element.id)
      })

      Npa.updateNpa({keyword: keywordId}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    deletePromotionHistory(id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        NpaModel.deleteNpaPromotionHistory(id)
          .then((res) => {
            this.npaPromotionHistories = res.data.npaPromotionHistories
            this.setLoading(false)
          })
          .catch((err) => {
            console.log(err)
            this.setLoading(false)
          })
      }
    },
    //добавляем Document
    getDocsData(documentList) {
      this.documentsData = documentList
      let fd = new FormData()
      console.log(this.documentsData);
      this.documentsData.forEach(function (element) {
        let description = element.description
        if (description === undefined) {
          description = null
        }
        console.log(element.file)
        fd.append('npa_document_type[uploadedFile]', element.file)
        fd.append('npa_document_type[description]', description)
        fd.append('npa_document_type[type]', element.type.id)
      })
      Npa.addNpaDocument(fd, this.npa.npa.id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.$refs.document.resetDocument()
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    //удаляем документ
    deleteDocument(id) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      Npa.deleteNpaDocument(this.npa.npa.id, id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    getExaminationsData(examinationsList) {
      this.examinationsData = Array.isArray(examinationsList) ? examinationsList : Object.values(examinationsList);

      let fd = new FormData();

      this.examinationsData.forEach((element, index) => {
        if (element.documents) {
          element.documents.forEach((doc, index) => {
            fd.append(`npa_examination_type[documents][${index}][file]`, doc.file);
            fd.append(`npa_examination_type[documents][${index}][name]`, doc.name);
          })
        }
        if (element.name) {
          fd.append(`npa_examination_type[name]`, element.name);
        }
        if (element.comment !== undefined) {
          fd.append(`npa_examination_type[comment]`, element.comment);
        }

        if (element.categories.length) {
          fd.append(`npa_examination_type[categories]`, element.categories);
        }
      });

      Npa.addNpaExamination(fd, this.npa.npa.id).then((response) => {
        let result = response.data;
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true);
          this.npa = response.data;
          this.$refs.examination.resetExamination();
          this.initFields();
          this.getNpaHistoryChangeList(this.npa.npa.id);
          this.setLoading(false);
        });
      });
    },

    //удаляем экспертизу
    deleteExamination(id) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      Npa.deleteNpaExamination(this.npa.npa.id, id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    //удаляем документ экспертизы
    deleteExaminationDocument(examinationId, documentId) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      Npa.deleteNpaExaminationDocument(examinationId, documentId).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    // изменение полей
    update_field(result) {
      if (result.status) {
        if (result.npa) {
          Search.getNpa(result.npa.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.generateBreadcrumbs(this.npa.npa.transName)
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.showInitiator()
            this.setLoading(false)
          })
        }
        this.fields[result.fieldName].showEdit = false
      }
    },
    // изменение даты публикации
    updateDate(date) {
      this.npa.npa.publish_date = date
      this.$refs.menu.save(date)
      Npa.updateNpa({publishDate: date}, this.npa.npa.id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    // изменение даты до
    updateDateFrom(date) {
      this.npa.npa.discussion_period_date_from = date
      this.$refs.menu2.save(date)
      Npa.updateNpa({discussionPeriodDateFrom: date}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    // изменение даты по
    updateDateTo(date) {
      this.npa.npa.discussion_period_date_to = date
      this.$refs.menu3.save(date)
      Npa.updateNpa({discussionPeriodDateTo: date}, this.npa.npa.id).then(
        (response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        }
      )
    },
    //добавляем блок
    getDataBlock(blockData) {
      this.blockData = blockData
      if (this.blockData.type == 'edit') {
        Npa.editNpaVersionBlock(
          this.blockData.blockId,
          this.blockData.versionId,
          {
            text: this.blockData.text,
            commented: this.blockData.commented
          }
        ).then((response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        })
      } else {
        Npa.addNpaVersionBlock(
          this.npa.npa.id,
          this.blockData.versionId,
          this.blockData.routeParam,
          {
            text: this.blockData.text,
            commented: this.blockData.commented
          }
        ).then((response) => {
          let result = response.data
          Search.getNpa(result.npa).then((response) => {
            this.setLoading(true)
            this.npa = response.data
            this.initFields()
            this.getNpaHistoryChangeList(this.npa.npa.id)
            this.setLoading(false)
          })
        })
      }
    },
    //удаляем блок
    deleteBlock(blockId, versionId) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      Npa.deleteNpaBlock(blockId, versionId).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.setLoading(false)
        })
      })
    },
    // ручная загрузка файла
    handleFileUploadVersion() {
      this.fileVersion = this.$refs.fileVersion.files[0]
      let formData = new FormData()
      formData.append('npa_version_file[uploadedFile]', this.fileVersion)
      Npa.editNpaVersionFile(
        this.currentVersionIdFile,
        this.npa.npa.id,
        this.currentLangFile,
        formData
      ).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.initFields()
          this.getNpaHistoryChangeList(this.npa.npa.id)
          this.currentVersionIdFile = null
          this.currentLangFile = null
          this.setLoading(false)
        })
      })
    },
    //вызов окна для выбора файла
    changeFileVersion(versionId, lang) {
      this.$refs.fileVersion.click()
      this.currentVersionIdFile = versionId
      this.currentLangFile = lang
    },
    // генерация хлебных крошек
    generateBreadcrumbs(name) {
      this.breadcrumbs = [{text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'}]
      var breadcrumb = {}
      breadcrumb.text = name
      breadcrumb.disabled = true
      this.breadcrumbs.push(breadcrumb)
    },
    // инициализация полей
    initFields() {
      this.fields = {
        nameKg: {
          name: 'nameKg',
          showEdit: false,
          fields: [
            {
              name: 'nameKg',
              label: 'Наименование на государственном языке',
              value: this.npa.npa.nameKg,
              type: 'textarea'
            }
          ]
        },
        name: {
          name: 'name',
          showEdit: false,
          fields: [
            {
              name: 'name',
              label: 'Наименование на официальном языке',
              value: this.npa.npa.name,
              type: 'textarea'
            }
          ]
        },
        view: {
          name: 'view',
          showEdit: false,
          model: 'refNpaView',
          fields: [
            {
              name: 'view',
              label: 'Вид проекта НПА',
              value: this.npa.npa.view.transName,
              type: 'references'
            }
          ]
        },
        region: {
          name: 'region',
          showEdit: false,
          model: 'refRegions',
          fields: [
            {
              name: 'region',
              label: 'Область',
              value: this.npa.npa.region ? this.npa.npa.region.transName : '',
              type: 'references'
            }
          ]
        },
        district: {
          name: 'district',
          showEdit: false,
          model: 'refDistricts',
          oldParams: `regionId=${this.npa.npa.region ? this.npa.npa.region.id : ''}`,
          fields: [
            {
              name: 'district',
              label: 'Район',
              value: this.npa.npa.district ? this.npa.npa.district.transName : '',
              type: 'references'
            }
          ]
        },
        edition: {
          name: 'edition',
          showEdit: false,
          model: 'refNpaEdition',
          fields: [
            {
              name: 'edition',
              label: 'Редакция',
              value: this.npa.npa.edition.transName,
              type: 'references'
            }
          ]
        },
        developer: {
          name: 'developer',
          showEdit: false,
          model: 'refDeveloper',
          fields: [
            {
              name: 'developer',
              label: 'Разработчик',
              value: this.npa.npa.developer.transName,
              type: 'references'
            }
          ]
        },
        initiator: {
          name: 'initiator',
          showEdit: false,
          model: 'refInitiator',
          fields: [
            {
              name: 'initiator',
              label: 'Инициатор проекта НПА',
              value: this.npa.npa.initiator ? this.npa.npa.initiator.transName : '',
              type: 'references'
            }
          ]
        },
        projectGoal: {
          name: 'projectGoal',
          showEdit: false,
          ckeditor: true,
          fields: [
            {
              name: 'projectGoal',
              label: 'Цель проекта НПА на официальном языке',
              value: this.npa.npa.project_goal,
              type: 'editor'
            }
          ]
        },
        projectGoalKg: {
          name: 'projectGoalKg',
          showEdit: false,
          ckeditor: true,
          fields: [
            {
              name: 'projectGoalKg',
              label: 'Цель проекта НПА на официальном языке',
              value: this.npa.npa.project_goal_kg,
              type: 'editor'
            }
          ]
        },
        publishDate: {
          menu: false,
          value: moment(this.npa.npa.publish_date).format('YYYY-MM-DD')
        },
        DateFrom: {
          menu: false,
          value: moment(this.npa.npa.discussion_period_date_from).format(
            'YYYY-MM-DD'
          )
        },
        DateTo: {
          menu: false,
          value: moment(this.npa.npa.discussion_period_date_to).format(
            'YYYY-MM-DD'
          )
        },
        category: {
          name: 'category',
          showEdit: false,
          model: 'refCategory',
          fields: [
            {
              name: 'category',
              label: 'Категории',
              value: this.npa.npa.category,
              type: 'referencesMultiply'
            }
          ]
        },
        branchLaw: {
          name: 'branchLaw',
          showEdit: false,
          model: 'refBranchLaw',
          fields: [
            {
              name: 'branchLaw',
              label: 'Отрасли',
              value: this.npa.npa.branch_law,
              type: 'referencesMultiply'
            }
          ]
        },
        keyword: {
          name: 'keyword',
          showEdit: false,
          model: 'refKeyword',
          fields: [
            {
              name: 'keyword',
              label: 'Ключевые слова',
              value: this.npa.npa.keywordIds,
              type: 'referencesMultiplyTreeview'
            }
          ]
        },
        fundingRequired: {
          name: 'fundingRequired',
          showEdit: false,
          fields: [
            {
              name: 'fundingRequired',
              label: 'Требует финансирования',
              value: this.npa.npa.funding_required,
              type: 'switch'
            }
          ]
        },
        entrepreneurshipAffect: {
          name: 'entrepreneurshipAffect',
          showEdit: false,
          fields: [
            {
              name: 'entrepreneurshipAffect',
              label: 'Затрагивает предпринимательскую деятельность',
              value: this.npa.npa.entrepreneurship_affect,
              type: 'switch'
            }
          ]
        },
        links: {
          name: 'links',
          showEdit: false,
          fields: [
            {
              name: 'links',
              label: 'Ссылки на НПА',
              value: this.npa.links,
              type: 'links'
            }
          ]
        },
        persons: {
          name: 'persons',
          showEdit: false,
          fields: [
            {
              name: 'persons',
              label: 'Контактные лица',
              value: this.npa.persons,
              type: 'persons'
            }
          ]
        }
      }
    },
    getNpaPromotionHistoryList(id) {
      NpaModel.getNpaPromotionHistoryList(id)
        .then((res) => {
          this.npaPromotionHistories = res.data.npaPromotionHistories
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getNpaHistoryChangeList(id) {
      NpaModel.getNpaHistoryChangeList(id)
        .then((res) => {
          this.npaHistoryChanges = res.data.items
        })
        .catch((err) => {
          console.log(err)
        })
    },
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    saveJkIdentifier() {
      if (!this.jkIdInput) return;

      this.setLoading(true);

      Npa.updateNpa({ jkId: this.jkIdInput.trim() }, this.npa.npa.id)
        .then(() => {
          this.jkDialog = false;
          this.jkIdInput = '';
          this.fetchData();
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.npa-version {
  .version-head {
    padding-top: 30px;
  }

  a:-webkit-any-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}

.block-control {
  margin: 20px 0;

  .flexbox {
    justify-content: flex-end;
  }
}
</style>
